<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Author-tp" xml:lang="en-GB">Raymond Pelly</p>
<p class="Title-tp">HEARTSCAPES</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/Logo-for-titlepages-new-bw.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-2.vue?aa048814